module.exports = __webpack_public_path__ + "static/media/people-culture.6ac9ba03.svg";